(function() {
  if (typeof document > "u" || "adoptedStyleSheets" in document)
    return;
  var t = "ShadyCSS" in window && !ShadyCSS.nativeShadow, e = document.implementation.createHTMLDocument(""), n = /* @__PURE__ */ new WeakMap(), a = typeof DOMException == "object" ? Error : DOMException, i = Object.defineProperty, l = Array.prototype.forEach, s = /@import.+?;?$/gm;
  function f(o) {
    var r = o.replace(s, "");
    return r !== o && console.warn("@import rules are not allowed here. See https://github.com/WICG/construct-stylesheets/issues/119#issuecomment-588352418"), r.trim();
  }
  function d(o) {
    return "isConnected" in o ? o.isConnected : document.contains(o);
  }
  function g(o) {
    return o.filter(function(r, c) {
      return o.indexOf(r) === c;
    });
  }
  function y(o, r) {
    return o.filter(function(c) {
      return r.indexOf(c) === -1;
    });
  }
  function L(o) {
    o.parentNode.removeChild(o);
  }
  function ne(o) {
    return o.shadowRoot || n.get(o);
  }
  var Ne = [
    "addRule",
    "deleteRule",
    "insertRule",
    "removeRule"
  ], Ve = CSSStyleSheet, V = Ve.prototype;
  V.replace = function() {
    return Promise.reject(new a("Can't call replace on non-constructed CSSStyleSheets."));
  }, V.replaceSync = function() {
    throw new a("Failed to execute 'replaceSync' on 'CSSStyleSheet': Can't call replaceSync on non-constructed CSSStyleSheets.");
  };
  function ae(o) {
    return typeof o == "object" ? F.isPrototypeOf(o) || V.isPrototypeOf(o) : !1;
  }
  function Re(o) {
    return typeof o == "object" ? V.isPrototypeOf(o) : !1;
  }
  var S = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
  function Pe(o, r) {
    var c = document.createElement("style");
    return R.get(o).set(r, c), M.get(o).push(r), c;
  }
  function C(o, r) {
    return R.get(o).get(r);
  }
  function Oe(o, r) {
    R.get(o).delete(r), M.set(o, M.get(o).filter(function(c) {
      return c !== r;
    }));
  }
  function oe(o, r) {
    requestAnimationFrame(function() {
      r.textContent = S.get(o).textContent, P.get(o).forEach(function(c) {
        return r.sheet[c.method].apply(r.sheet, c.args);
      });
    });
  }
  function O(o) {
    if (!S.has(o))
      throw new TypeError("Illegal invocation");
  }
  function K() {
    var o = this, r = document.createElement("style");
    e.body.appendChild(r), S.set(o, r), M.set(o, []), R.set(o, /* @__PURE__ */ new WeakMap()), P.set(o, []);
  }
  var F = K.prototype;
  F.replace = function(r) {
    try {
      return this.replaceSync(r), Promise.resolve(this);
    } catch (c) {
      return Promise.reject(c);
    }
  }, F.replaceSync = function(r) {
    if (O(this), typeof r == "string") {
      var c = this;
      S.get(c).textContent = f(r), P.set(c, []), M.get(c).forEach(function(h) {
        h.isConnected() && oe(c, C(c, h));
      });
    }
  }, i(F, "cssRules", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return O(this), S.get(this).sheet.cssRules;
    }
  }), i(F, "media", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return O(this), S.get(this).sheet.media;
    }
  }), Ne.forEach(function(o) {
    F[o] = function() {
      var r = this;
      O(r);
      var c = arguments;
      P.get(r).push({ method: o, args: c }), M.get(r).forEach(function(p) {
        if (p.isConnected()) {
          var u = C(r, p).sheet;
          u[o].apply(u, c);
        }
      });
      var h = S.get(r).sheet;
      return h[o].apply(h, c);
    };
  }), i(K, Symbol.hasInstance, {
    configurable: !0,
    value: ae
  });
  var re = {
    childList: !0,
    subtree: !0
  }, ie = /* @__PURE__ */ new WeakMap();
  function I(o) {
    var r = ie.get(o);
    return r || (r = new ce(o), ie.set(o, r)), r;
  }
  function se(o) {
    i(o.prototype, "adoptedStyleSheets", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        return I(this).sheets;
      },
      set: function(r) {
        I(this).update(r);
      }
    });
  }
  function G(o, r) {
    for (var c = document.createNodeIterator(
      o,
      NodeFilter.SHOW_ELEMENT,
      function(p) {
        return ne(p) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
      null,
      !1
    ), h = void 0; h = c.nextNode(); )
      r(ne(h));
  }
  var W = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap();
  function We(o, r) {
    return r instanceof HTMLStyleElement && k.get(o).some(function(c) {
      return C(c, o);
    });
  }
  function le(o) {
    var r = W.get(o);
    return r instanceof Document ? r.body : r;
  }
  function J(o) {
    var r = document.createDocumentFragment(), c = k.get(o), h = D.get(o), p = le(o);
    h.disconnect(), c.forEach(function(u) {
      r.appendChild(C(u, o) || Pe(u, o));
    }), p.insertBefore(r, null), h.observe(p, re), c.forEach(function(u) {
      oe(u, C(u, o));
    });
  }
  function ce(o) {
    var r = this;
    r.sheets = [], W.set(r, o), k.set(r, []), D.set(r, new MutationObserver(function(c, h) {
      if (!document) {
        h.disconnect();
        return;
      }
      c.forEach(function(p) {
        t || l.call(p.addedNodes, function(u) {
          u instanceof Element && G(u, function(A) {
            I(A).connect();
          });
        }), l.call(p.removedNodes, function(u) {
          u instanceof Element && (We(r, u) && J(r), t || G(u, function(A) {
            I(A).disconnect();
          }));
        });
      });
    }));
  }
  if (ce.prototype = {
    isConnected: function() {
      var o = W.get(this);
      return o instanceof Document ? o.readyState !== "loading" : d(o.host);
    },
    connect: function() {
      var o = le(this);
      D.get(this).observe(o, re), k.get(this).length > 0 && J(this), G(o, function(r) {
        I(r).connect();
      });
    },
    disconnect: function() {
      D.get(this).disconnect();
    },
    update: function(o) {
      var r = this, c = W.get(r) === document ? "Document" : "ShadowRoot";
      if (!Array.isArray(o))
        throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + c + ": Iterator getter is not callable.");
      if (!o.every(ae))
        throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + c + ": Failed to convert value to 'CSSStyleSheet'");
      if (o.some(Re))
        throw new TypeError("Failed to set the 'adoptedStyleSheets' property on " + c + ": Can't adopt non-constructed stylesheets");
      r.sheets = o;
      var h = k.get(r), p = g(o), u = y(h, p);
      u.forEach(function(A) {
        L(C(A, r)), Oe(A, r);
      }), k.set(r, p), r.isConnected() && p.length > 0 && J(r);
    }
  }, window.CSSStyleSheet = K, se(Document), "ShadowRoot" in window) {
    se(ShadowRoot);
    var de = Element.prototype, De = de.attachShadow;
    de.attachShadow = function(r) {
      var c = De.call(this, r);
      return r.mode === "closed" && n.set(this, c), c;
    };
  }
  var H = I(document);
  H.isConnected() ? H.connect() : document.addEventListener("DOMContentLoaded", H.connect.bind(H));
})();
const v = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), ue = /* @__PURE__ */ new WeakMap(), He = /* @__PURE__ */ new WeakMap(), Y = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), Se = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), Me = /* @__PURE__ */ new WeakMap(), fe = /* @__PURE__ */ new WeakMap(), Ce = /* @__PURE__ */ new WeakMap(), he = /* @__PURE__ */ new WeakMap(), q = /* @__PURE__ */ new WeakMap(), B = {
  ariaAtomic: "aria-atomic",
  ariaAutoComplete: "aria-autocomplete",
  ariaBrailleLabel: "aria-braillelabel",
  ariaBrailleRoleDescription: "aria-brailleroledescription",
  ariaBusy: "aria-busy",
  ariaChecked: "aria-checked",
  ariaColCount: "aria-colcount",
  ariaColIndex: "aria-colindex",
  ariaColIndexText: "aria-colindextext",
  ariaColSpan: "aria-colspan",
  ariaCurrent: "aria-current",
  ariaDescription: "aria-description",
  ariaDisabled: "aria-disabled",
  ariaExpanded: "aria-expanded",
  ariaHasPopup: "aria-haspopup",
  ariaHidden: "aria-hidden",
  ariaInvalid: "aria-invalid",
  ariaKeyShortcuts: "aria-keyshortcuts",
  ariaLabel: "aria-label",
  ariaLevel: "aria-level",
  ariaLive: "aria-live",
  ariaModal: "aria-modal",
  ariaMultiLine: "aria-multiline",
  ariaMultiSelectable: "aria-multiselectable",
  ariaOrientation: "aria-orientation",
  ariaPlaceholder: "aria-placeholder",
  ariaPosInSet: "aria-posinset",
  ariaPressed: "aria-pressed",
  ariaReadOnly: "aria-readonly",
  ariaRelevant: "aria-relevant",
  ariaRequired: "aria-required",
  ariaRoleDescription: "aria-roledescription",
  ariaRowCount: "aria-rowcount",
  ariaRowIndex: "aria-rowindex",
  ariaRowIndexText: "aria-rowindextext",
  ariaRowSpan: "aria-rowspan",
  ariaSelected: "aria-selected",
  ariaSetSize: "aria-setsize",
  ariaSort: "aria-sort",
  ariaValueMax: "aria-valuemax",
  ariaValueMin: "aria-valuemin",
  ariaValueNow: "aria-valuenow",
  ariaValueText: "aria-valuetext",
  role: "role"
}, $e = (t, e) => {
  for (let n in B) {
    e[n] = null;
    let a = null;
    const i = B[n];
    Object.defineProperty(e, n, {
      get() {
        return a;
      },
      set(l) {
        a = l, t.isConnected ? b(t, i, l) : _.set(t, e);
      }
    });
  }
};
function pe(t) {
  const e = m.get(t), { form: n } = e;
  Te(t, n, e), Ae(t, e.labels);
}
const Fe = (t, e = !1) => {
  const n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode(l) {
      return m.has(l) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  let a = n.nextNode();
  const i = !e || t.disabled;
  for (; a; )
    a.formDisabledCallback && i && te(a, t.disabled), a = n.nextNode();
}, Ie = { attributes: !0, attributeFilter: ["disabled", "name"] }, T = j() ? new MutationObserver((t) => {
  for (const e of t) {
    const n = e.target;
    if (e.attributeName === "disabled" && (n.constructor.formAssociated ? te(n, n.hasAttribute("disabled")) : n.localName === "fieldset" && Fe(n)), e.attributeName === "name" && n.constructor.formAssociated) {
      const a = m.get(n), i = Se.get(n);
      a.setFormValue(i);
    }
  }
}) : {};
function Z(t) {
  t.forEach((e) => {
    const { addedNodes: n, removedNodes: a } = e, i = Array.from(n), l = Array.from(a);
    i.forEach((s) => {
      var f;
      if (m.has(s) && s.constructor.formAssociated && pe(s), _.has(s)) {
        const d = _.get(s);
        Object.keys(B).filter((y) => d[y] !== null).forEach((y) => {
          b(s, B[y], d[y]);
        }), _.delete(s);
      }
      if (q.has(s)) {
        const d = q.get(s);
        b(s, "internals-valid", d.validity.valid.toString()), b(s, "internals-invalid", (!d.validity.valid).toString()), b(s, "aria-invalid", (!d.validity.valid).toString()), q.delete(s);
      }
      if (s.localName === "form") {
        const d = E.get(s), g = document.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, {
          acceptNode(L) {
            return m.has(L) && L.constructor.formAssociated && !(d && d.has(L)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
          }
        });
        let y = g.nextNode();
        for (; y; )
          pe(y), y = g.nextNode();
      }
      s.localName === "fieldset" && ((f = T.observe) == null || f.call(T, s, Ie), Fe(s, !0));
    }), l.forEach((s) => {
      const f = m.get(s);
      f && N.get(f) && ke(f), Y.has(s) && Y.get(s).disconnect();
    });
  });
}
function _e(t) {
  t.forEach((e) => {
    const { removedNodes: n } = e;
    n.forEach((a) => {
      const i = Ce.get(e.target);
      m.has(a) && Le(a), i.disconnect();
    });
  });
}
const qe = (t) => {
  var n, a;
  const e = new MutationObserver(_e);
  (n = window == null ? void 0 : window.ShadyDOM) != null && n.inUse && t.mode && t.host && (t = t.host), (a = e.observe) == null || a.call(e, t, { childList: !0 }), Ce.set(t, e);
};
j() && new MutationObserver(Z);
const Q = {
  childList: !0,
  subtree: !0
}, b = (t, e, n) => {
  t.getAttribute(e) !== n && t.setAttribute(e, n);
}, te = (t, e) => {
  t.toggleAttribute("internals-disabled", e), e ? b(t, "aria-disabled", "true") : t.removeAttribute("aria-disabled"), t.formDisabledCallback && t.formDisabledCallback.apply(t, [e]);
}, ke = (t) => {
  N.get(t).forEach((n) => {
    n.remove();
  }), N.set(t, []);
}, me = (t, e) => {
  const n = document.createElement("input");
  return n.type = "hidden", n.name = t.getAttribute("name"), t.after(n), N.get(e).push(n), n;
}, Be = (t, e) => {
  var n;
  N.set(e, []), (n = T.observe) == null || n.call(T, t, Ie);
}, Ae = (t, e) => {
  if (e.length) {
    const n = Array.from(e);
    n.forEach((l) => l.addEventListener("click", t.click.bind(t)));
    const [a] = n;
    let i = a.id;
    a.id || (i = `${a.htmlFor}_Label`, a.id = i), b(t, "aria-labelledby", i);
  }
}, z = (t) => {
  const e = Array.from(t.elements).filter((l) => !l.tagName.includes("-") && l.validity).map((l) => l.validity.valid), n = E.get(t) || [], a = Array.from(n).filter((l) => l.isConnected).map((l) => m.get(l).validity.valid), i = [...e, ...a].includes(!1);
  t.toggleAttribute("internals-invalid", i), t.toggleAttribute("internals-valid", !i);
}, je = (t) => {
  z(U(t.target));
}, ze = (t) => {
  z(U(t.target));
}, Ue = (t) => {
  const e = [
    "button[type=submit]",
    "input[type=submit]",
    "button:not([type])"
  ].map((n) => `${n}:not([disabled])`).map((n) => `${n}:not([form])${t.id ? `,${n}[form='${t.id}']` : ""}`).join(",");
  t.addEventListener("click", (n) => {
    if (n.target.closest(e)) {
      const i = E.get(t);
      if (t.noValidate)
        return;
      i.size && Array.from(i).reverse().map((f) => m.get(f).reportValidity()).includes(!1) && n.preventDefault();
    }
  });
}, Ke = (t) => {
  const e = E.get(t.target);
  e && e.size && e.forEach((n) => {
    n.constructor.formAssociated && n.formResetCallback && n.formResetCallback.apply(n);
  });
}, Te = (t, e, n) => {
  if (e) {
    const a = E.get(e);
    if (a)
      a.add(t);
    else {
      const i = /* @__PURE__ */ new Set();
      i.add(t), E.set(e, i), Ue(e), e.addEventListener("reset", Ke), e.addEventListener("input", je), e.addEventListener("change", ze);
    }
    He.set(e, { ref: t, internals: n }), t.constructor.formAssociated && t.formAssociatedCallback && setTimeout(() => {
      t.formAssociatedCallback.apply(t, [e]);
    }, 0), z(e);
  }
}, U = (t) => {
  let e = t.parentNode;
  return e && e.tagName !== "FORM" && (e = U(e)), e;
}, w = (t, e, n = DOMException) => {
  if (!t.constructor.formAssociated)
    throw new n(e);
}, ye = (t, e, n) => {
  const a = E.get(t);
  return a && a.size && a.forEach((i) => {
    m.get(i)[n]() || (e = !1);
  }), e;
}, Le = (t) => {
  if (t.constructor.formAssociated) {
    const e = m.get(t), { labels: n, form: a } = e;
    Ae(t, n), Te(t, a, e);
  }
};
function j() {
  return typeof MutationObserver < "u";
}
class Ge {
  constructor() {
    this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
  }
}
const Je = (t) => (t.badInput = !1, t.customError = !1, t.patternMismatch = !1, t.rangeOverflow = !1, t.rangeUnderflow = !1, t.stepMismatch = !1, t.tooLong = !1, t.tooShort = !1, t.typeMismatch = !1, t.valid = !0, t.valueMissing = !1, t), Qe = (t, e, n) => (t.valid = Xe(e), Object.keys(e).forEach((a) => t[a] = e[a]), n && z(n), t), Xe = (t) => {
  let e = !0;
  for (let n in t)
    n !== "valid" && t[n] !== !1 && (e = !1);
  return e;
}, X = /* @__PURE__ */ new WeakMap();
function ge(t, e) {
  t.toggleAttribute(e, !0), t.part && t.part.add(e);
}
class ee extends Set {
  static get isPolyfilled() {
    return !0;
  }
  constructor(e) {
    if (super(), !e || !e.tagName || e.tagName.indexOf("-") === -1)
      throw new TypeError("Illegal constructor");
    X.set(this, e);
  }
  add(e) {
    if (!/^--/.test(e) || typeof e != "string")
      throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${e} must start with '--'.`);
    const n = super.add(e), a = X.get(this), i = `state${e}`;
    return a.isConnected ? ge(a, i) : setTimeout(() => {
      ge(a, i);
    }), n;
  }
  clear() {
    for (let [e] of this.entries())
      this.delete(e);
    super.clear();
  }
  delete(e) {
    const n = super.delete(e), a = X.get(this);
    return a.isConnected ? (a.toggleAttribute(`state${e}`, !1), a.part && a.part.remove(`state${e}`)) : setTimeout(() => {
      a.toggleAttribute(`state${e}`, !1), a.part && a.part.remove(`state${e}`);
    }), n;
  }
}
var Ye = function(t, e, n, a, i) {
  if (a === "m") throw new TypeError("Private method is not writable");
  if (a === "a" && !i) throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return a === "a" ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
}, ve = function(t, e, n, a) {
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? a : n === "a" ? a.call(t) : a ? a.value : e.get(t);
}, x;
class Ze {
  constructor(e) {
    x.set(this, void 0), Ye(this, x, e, "f");
    for (let n = 0; n < e.length; n++) {
      let a = e[n];
      this[n] = a, a.hasAttribute("name") && (this[a.getAttribute("name")] = a);
    }
    Object.freeze(this);
  }
  get length() {
    return ve(this, x, "f").length;
  }
  [(x = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
    return ve(this, x, "f")[Symbol.iterator]();
  }
  item(e) {
    return this[e] == null ? null : this[e];
  }
  namedItem(e) {
    return this[e] == null ? null : this[e];
  }
}
function et() {
  const t = HTMLFormElement.prototype.checkValidity;
  HTMLFormElement.prototype.checkValidity = n;
  const e = HTMLFormElement.prototype.reportValidity;
  HTMLFormElement.prototype.reportValidity = a;
  function n(...l) {
    let s = t.apply(this, l);
    return ye(this, s, "checkValidity");
  }
  function a(...l) {
    let s = e.apply(this, l);
    return ye(this, s, "reportValidity");
  }
  const { get: i } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
  Object.defineProperty(HTMLFormElement.prototype, "elements", {
    get(...l) {
      const s = i.call(this, ...l), f = Array.from(E.get(this) || []);
      if (f.length === 0)
        return s;
      const d = Array.from(s).concat(f).sort((g, y) => g.compareDocumentPosition ? g.compareDocumentPosition(y) & 2 ? 1 : -1 : 0);
      return new Ze(d);
    }
  });
}
class we {
  static get isPolyfilled() {
    return !0;
  }
  constructor(e) {
    if (!e || !e.tagName || e.tagName.indexOf("-") === -1)
      throw new TypeError("Illegal constructor");
    const n = e.getRootNode(), a = new Ge();
    this.states = new ee(e), v.set(this, e), $.set(this, a), m.set(e, this), $e(e, this), Be(e, this), Object.seal(this), n instanceof DocumentFragment && qe(n);
  }
  /**
   * Will return true if the element is in a valid state
   */
  checkValidity() {
    const e = v.get(this);
    if (w(e, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
      return !0;
    const n = $.get(this);
    if (!n.valid) {
      const a = new Event("invalid", {
        bubbles: !1,
        cancelable: !0,
        composed: !1
      });
      e.dispatchEvent(a);
    }
    return n.valid;
  }
  /** The form element the custom element is associated with */
  get form() {
    const e = v.get(this);
    w(e, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
    let n;
    return e.constructor.formAssociated === !0 && (n = U(e)), n;
  }
  /** A list of all relative form labels for this element */
  get labels() {
    const e = v.get(this);
    w(e, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
    const n = e.getAttribute("id"), a = e.getRootNode();
    return a && n ? a.querySelectorAll(`[for="${n}"]`) : [];
  }
  /** Will report the elements validity state */
  reportValidity() {
    const e = v.get(this);
    if (w(e, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
      return !0;
    const n = this.checkValidity(), a = fe.get(this);
    if (a && !e.constructor.formAssociated)
      throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
    return !n && a && (e.focus(), a.focus()), n;
  }
  /** Sets the element's value within the form */
  setFormValue(e) {
    const n = v.get(this);
    if (w(n, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), ke(this), e != null && !(e instanceof FormData)) {
      if (n.getAttribute("name")) {
        const a = me(n, this);
        a.value = e;
      }
    } else e != null && e instanceof FormData && Array.from(e).reverse().forEach(([a, i]) => {
      if (typeof i == "string") {
        const l = me(n, this);
        l.name = a, l.value = i;
      }
    });
    Se.set(n, e);
  }
  /**
   * Sets the element's validity. The first argument is a partial ValidityState object
   * reflecting the changes to be made to the element's validity. If the element is invalid,
   * the second argument sets the element's validation message.
   *
   * If the field is valid and a message is specified, the method will throw a TypeError.
   */
  setValidity(e, n, a) {
    const i = v.get(this);
    if (w(i, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !e)
      throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
    fe.set(this, a);
    const l = $.get(this), s = {};
    for (const g in e)
      s[g] = e[g];
    Object.keys(s).length === 0 && Je(l);
    const f = { ...l, ...s };
    delete f.valid;
    const { valid: d } = Qe(l, f, this.form);
    if (!d && !n)
      throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
    ue.set(this, d ? "" : n), i.isConnected ? (i.toggleAttribute("internals-invalid", !d), i.toggleAttribute("internals-valid", d), b(i, "aria-invalid", `${!d}`)) : q.set(i, this);
  }
  get shadowRoot() {
    const e = v.get(this), n = Me.get(e);
    return n || null;
  }
  /** The element's validation message set during a call to ElementInternals.setValidity */
  get validationMessage() {
    const e = v.get(this);
    return w(e, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), ue.get(this);
  }
  /** The current validity state of the object */
  get validity() {
    const e = v.get(this);
    return w(e, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), $.get(this);
  }
  /** If true the element will participate in a form's constraint validation. */
  get willValidate() {
    const e = v.get(this);
    return w(e, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(e.matches(":disabled") || e.disabled || e.hasAttribute("disabled") || e.hasAttribute("readonly"));
  }
}
function tt() {
  if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
    return !1;
  class t extends HTMLElement {
    constructor() {
      super(), this.internals = this.attachInternals();
    }
  }
  const e = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
  customElements.define(e, t);
  const n = new t();
  return [
    "shadowRoot",
    "form",
    "willValidate",
    "validity",
    "validationMessage",
    "labels",
    "setFormValue",
    "setValidity",
    "checkValidity",
    "reportValidity"
  ].every((a) => a in n.internals);
}
let be = !1, Ee = !1;
function xe(t) {
  Ee || (Ee = !0, window.CustomStateSet = ee, t && (HTMLElement.prototype.attachInternals = function(...e) {
    const n = t.call(this, e);
    return n.states = new ee(this), n;
  }));
}
function nt(t = !0) {
  if (!be) {
    if (be = !0, typeof window < "u" && (window.ElementInternals = we), typeof CustomElementRegistry < "u") {
      const n = CustomElementRegistry.prototype.define;
      CustomElementRegistry.prototype.define = function(a, i, l) {
        if (i.formAssociated) {
          const s = i.prototype.connectedCallback;
          i.prototype.connectedCallback = function() {
            he.has(this) || (he.set(this, !0), this.hasAttribute("disabled") && te(this, !0)), s != null && s.apply(this), Le(this);
          };
        }
        n.call(this, a, i, l);
      };
    }
    if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
      if (this.tagName) {
        if (this.tagName.indexOf("-") === -1)
          throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
      } else return {};
      if (m.has(this))
        throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
      return new we(this);
    }), typeof Element < "u") {
      let n = function(...i) {
        const l = a.apply(this, i);
        if (Me.set(this, l), j()) {
          const s = new MutationObserver(Z);
          window.ShadyDOM ? s.observe(this, Q) : s.observe(l, Q), Y.set(this, s);
        }
        return l;
      };
      var e = n;
      const a = Element.prototype.attachShadow;
      Element.prototype.attachShadow = n;
    }
    j() && typeof document < "u" && new MutationObserver(Z).observe(document.documentElement, Q), typeof HTMLFormElement < "u" && et(), (t || typeof window < "u" && !window.CustomStateSet) && xe();
  }
}
const at = !!customElements.polyfillWrapFlushCallback;
at || (tt() ? typeof window < "u" && !window.CustomStateSet && xe(HTMLElement.prototype.attachInternals) : nt(!1));
